module.exports = __webpack_public_path__ + "img/emoji_86.c69e7924.png";